import { Worlds } from '../mode/Mode';
import cardCB1 from '../../media/questionnaires/cb_1.png';
import cardCB2 from '../../media/questionnaires/cb_2.png';
import cardCB3 from '../../media/questionnaires/cb_3.png';
import cardCB4 from '../../media/questionnaires/cb_4.png';
import cardCB5 from '../../media/questionnaires/cb_5.png';
import cardCM1 from '../../media/questionnaires/cm_1.png';
import cardCM2 from '../../media/questionnaires/cm_2.png';
import cardCM3 from '../../media/questionnaires/cm_3.png';
import cardCM4 from '../../media/questionnaires/cm_4.png';
import cardCM5 from '../../media/questionnaires/cm_5.png';
import cardCM6 from '../../media/questionnaires/cm_6.png';
import cardCA1 from '../../media/questionnaires/ca_1.png';
import cardCA2 from '../../media/questionnaires/ca_2.png';
import cardCA3 from '../../media/questionnaires/ca_3.png';
import cardCA4 from '../../media/questionnaires/ca_4.png';
import cardCA5 from '../../media/questionnaires/ca_5.png';
import cardCA6 from '../../media/questionnaires/ca_6.png';
import cardGL1 from '../../media/questionnaires/gl_1.png';
import cardGL2 from '../../media/questionnaires/gl_2.png';
import cardGL3 from '../../media/questionnaires/gl_3.png';
import cardGL4 from '../../media/questionnaires/gl_4.png';
import cardGL5 from '../../media/questionnaires/gl_5.png';
import cardGL6 from '../../media/questionnaires/gl_6.png';

type Questionnaires = {
    [key in Worlds]: Array<Question>;
};

interface Question {
    text: string;
    options: Array<string>;
    correctIndex: number;
    cardImage: string;
    audio?: string;
    video?: string;
    copyright?: string;
}

const questionnaires: Questionnaires = {
    'cuenca-alta': [
        {
            text: '¿Qué es Cuenca Hidrográfica?',
            options: [
                'Territorio en el que se pueden extraer minerales como el oro, plata y cobre',
                'Se conoce exclusivamente como el área de captación de donde provienen las aguas de un río, quebrada, lago, laguna, humedal o acuífero',
                'Una cuenca no es solamente agua, también está conformada por las maneras en que se relacionan los habitantes y sus acciones cotidianas con los suelos, la biodiversidad y los demás elementos naturales',
            ],
            correctIndex: 2,
            cardImage: cardCA1,
            audio: 'sq__ca_familias',
        },
        {
            text: '¿Dónde nace el Río Otún?',
            options: ['Río Risaralda', 'Laguna del Otún', 'Río Cauca'],
            correctIndex: 1,
            cardImage: cardCA2,
            audio: 'sq__ca_2',
        },
        {
            text: '¿Cuál de estas aves habita en la Cuenca del Río Otún?',
            options: ['El pingüino', 'La pava caucana', 'El flamenco'],
            correctIndex: 1,
            cardImage: cardCA3,
            audio: 'sq__ca_3',
        },
        {
            text: 'De las siguientes especies, ¿cuál habita en la Cuenca Alta del Río Otún?',
            options: ['El camello', 'La jirafa', 'La Danta'],
            correctIndex: 2,
            cardImage: cardCA4,
        },
        {
            text: 'De las siguientes especies vegetales, ¿cuál es nativa de la zona alta del Río Otún?',
            options: ['El eucalipto', 'El cedro', 'El pino'],
            correctIndex: 1,
            cardImage: cardCA5,
        },
        {
            text: '¿Qué función cumple un frailejón?',
            options: [
                'Captar la humedad del entorno y almacenar el líquido vital para nutrir las quebradas y ríos',
                'Capturar el oxígeno y convertirlo en dióxido de carbono',
                'Invadir los páramos y bosques',
            ],
            correctIndex: 0,
            cardImage: cardCA6,
        },
    ],
    'cuenca-media': [
        {
            text: 'El agua que llega a la casa viene de:',
            options: ['Un tubo', 'Un río', 'De la casa del vecino'],
            correctIndex: 1,
            cardImage: cardCM1,
            audio: 'sq__cm_descubrir',
        },
        {
            text: '¿Cuántos litros de agua consideras se gasta una persona por minuto mientras se baña?',
            options: ['20 litros', '1 litro', '200 litros'],
            correctIndex: 0,
            cardImage: cardCM2,
            audio: 'sq__cm_lideres',
        },
        {
            text: 'Un sumidero es',
            options: [
                'Tanque de reserva de agua potable',
                'Conducto que canaliza las aguas lluvia',
                'Árbol de gran tamaño que habita en la cuenca del Río Otún',
            ],
            correctIndex: 1,
            cardImage: cardCM3,
            audio: 'sq__cm_potencial',
        },
        {
            text: 'Seleccione los siguientes alimentos que puedes cultivar desde casa',
            options: ['Zanahoria y tomate', 'Cebolla y cilantro', 'Todas las anteriores', 'Ninguna de las anteriores'],
            correctIndex: 2,
            cardImage: cardCM4,
            audio: 'sq__cm_sectores',
        },
        {
            text: 'Seleccione las plantas que atraen a las abejas',
            options: ['Romero, hinojo y caléndula', 'Margaritas y girasoles', 'Todas las anteriores'],
            correctIndex: 2,
            cardImage: cardCM5,
        },
        {
            text: 'Seleccione los siguientes animales que polinizan',
            options: ['Las abejas', 'Las mariposas', 'Los colibríes', 'Los murciélagos', 'Todas las anteriores'],
            correctIndex: 4,
            cardImage: cardCM6,
        },
    ],
    'cuenca-baja': [
        {
            text: 'Seleccione las siguientes acciones que ayudan a cuidar el Río',
            options: [
                'Sembrar árboles, recoger basuras',
                'Talar árboles y arrojar basuras',
                'Ninguna de las anteriores',
                'Todas las anteriores',
            ],
            correctIndex: 0,
            cardImage: cardCB1,
        },
        {
            text: '¿Qué es agua potable?',
            options: [
                'Agua libre de microorganismos y sustancias tóxicas',
                'Agua que proviene directamente del río',
                'Agua lluvia',
            ],
            correctIndex: 0,
            cardImage: cardCB2,
            audio: 'sq__cb_nacimiento',
        },
        {
            text: '¿Qué es Planta de Tratamiento de Aguas Residuales PTAR?',
            options: [
                'Es una planta donde llegan las Aguas Residuales para recibir un tratamiento que permita su descontaminación, para así devolverlas al río en óptimas condiciones, cerrando el ciclo del agua a través de la limpieza del río.',
                'Lugar en donde se almacena el agua potable',
                'Ninguna de las anteriores',
            ],
            correctIndex: 0,
            cardImage: cardCB3,
            audio: 'sq__cb_3',
        },
        {
            text: '¿Dónde desemboca el Río Otún?',
            options: ['Laguna del Otún', 'Río Cauca', 'Río Orinoco', 'Quebrada La Víbora'],
            correctIndex: 1,
            cardImage: cardCB4,
            audio: 'sq__cb_desemboca',
        },
        {
            text: '¿Cuál de las siguientes especies animales habitan en la Cuenca Baja del Río Otún?',
            options: ['La iguana', 'El guatín', 'La zarigüeya', 'El zorro', 'El barranquero', 'Todas las anteriores'],
            correctIndex: 5,
            cardImage: cardCB5,
        },
    ],
    glaciar: [
        {
            text: '¿Qué es Glaciar?',
            options: [
                'Estructura que sirve de refugio para diferentes especies animales',
                'Masa de hielo y nieve que, generalmente, está en movimiento',
                'Ninguna de las anteriores',
            ],
            correctIndex: 1,
            cardImage: cardGL1,
            audio: 'sq__gl_1',
            video: '5i0l6l4d_EY',
            copyright: 'Alejandro Ospina',
        },
        {
            text: 'Los glaciares se clasifican según su:',
            options: ['Clima', 'Forma', 'Ubicación', 'Condiciones topográficas', 'Todas las anteriores'],
            correctIndex: 4,
            cardImage: cardGL2,
            audio: 'sq__gl_2',
            copyright: 'Alejandro Ospina',
        },
        {
            text: '¿Cuántos Glaciares existen en Colombia?',
            options: ['6', '2', '10'],
            correctIndex: 0,
            cardImage: cardGL6,
            audio: 'sq__gl_3',
            video: 'Ahs8Wwf35VU',
            copyright: 'Ideam',
        },
        {
            text: '¿Qué tipo de especies animales se encuentran en el Glaciar de Santa Isabel?',
            options: ['No existen especies animales que habiten el glaciar', 'El oso de anteojos', 'Pingüinos'],
            correctIndex: 0,
            cardImage: cardGL4,
            audio: 'sq__gl_preocupacion',
            copyright: 'Ideam',
        },
        {
            text: '¿Qué tipo de especies vegetales se encuentran en Alta Montaña?',
            options: ['Los pinos', 'Los frailejones', 'El yarumo blanco'],
            correctIndex: 1,
            cardImage: cardGL5,
            audio: 'sq__gl_sistema',
            copyright: ' Eduardo Tobón',
        },
        {
            text: '¿Cómo se monitorean los glaciares?',
            options: [
                'No se monitorean',
                'En terreno de campo y análisis fotográfico',
                'A través de las plantas de tratamiento',
                'Ninguna de las anteriores',
            ],
            correctIndex: 1,
            cardImage: cardGL3,
            audio: 'sq__gl_6',
            video: '-4YD1J5BiI8',
            copyright: 'Antoine Kremer',
        },
    ],
};

export default questionnaires;
